<i18n>
{
  "en": {
    "revenue": "Revenue"
  },
  "es": {
    "revenue": "Ingresos"
  }
}
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import * as KPITypes from '../constants';
import KpiComponent from './KpiComponent.vue';

@Component
@MapActions(['calculateTotalRevenueKPI'])
export default class RevenueKpi extends KpiComponent {
  icon = 'fas fa-funnel-dollar'

  iconSize = 21;

  kpiType = KPITypes.TOTAL_REVENUE

  isCurrencyUnit = true

  get title() {
    return this.$t('revenue');
  }

  async calculate() {
    await this.calculateTotalRevenueKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
